import React from "react";
import { Link } from "react-router-dom";

const GENERAL_MASTERS = [
  { label: "Agency Details", icon: "bi bi-people-fill", to: "/agency/list" },
  { label: "Airline", icon: "bi-airplane-fill", to: "/airlines-details" },
  { label: "Airport", icon: "bi-airplane-engines-fill", to: "/airports-details" },
];

const LOCATION_MASTERS = [
  { label: "Country", icon: "bi-globe", to: "/location/countries" },
  { label: "State", icon: "bi-map-fill", to: "/location/states" },
  { label: "City", icon: "bi-building", to: "/location/cities" },
];

const MASTER_CONFIGURATION = [
  { label: "Flight Api Search Restrictions", icon: "bi-truck", to: null },
  { label: "Airline Search Restrictions", icon: "bi-airplane-fill", to: null },
  { label: "Flight Api Fare Types", icon: "bi-airplane-fill", to: null },
];

const cardStyle = { borderRadius: 14, overflow: "hidden" };
const headerStyle = { background: "#1e293b", color: "#fff", fontSize: 13, fontWeight: 700, padding: "12px 16px" };

const SettingItem = ({ item }) => {
  const content = (
    <>
      <span
        className="d-flex align-items-center justify-content-center"
        style={{ width: 32, height: 32, borderRadius: 8, background: "#eef1f7", color: "#4a5568", fontSize: 14 }}
      >
        <i className={`bi ${item.icon}`}></i>
      </span>
      <span style={{ fontSize: 13, color: "#4a5568" }}>{item.label}</span>
    </>
  );
  const className = "d-flex align-items-center gap-3 px-3 py-2 text-decoration-none";
  return item.to ? (
    <Link to={item.to} className={className}>{content}</Link>
  ) : (
    <div className={className} style={{ cursor: "default" }}>{content}</div>
  );
};

const Setting = () => (
  <section className="section dashboard">
    <div className="mb-3">
      <h4 className="m-0 fw-bold" style={{ color: "#1a202c", fontSize: 20 }}>Settings</h4>
      <nav className="d-flex align-items-center gap-1 mt-1" style={{ fontSize: 12, color: "#8a9ab5" }}>
        <Link to="/" style={{ color: "#8a9ab5" }}><i className="bi bi-house-door"></i></Link>
        <i className="bi bi-chevron-right" style={{ fontSize: 9 }}></i>        
        <span className="fw-semibold" style={{ color: "#4a5568" }}>Settings</span>
      </nav>
    </div>

    <div className="row g-3 mb-4">    
      <div className="col-12 col-md-auto">
        <div className="card border-0 shadow-sm h-100" style={{ ...cardStyle, width: 400, maxWidth: "100%" }}>
          <div style={headerStyle}>General Masters</div>
          <div className="py-1">
            {GENERAL_MASTERS.map((item) => <SettingItem key={item.label} item={item} />)}
          </div>
        </div>
      </div>
      <div className="col-12 col-md-auto">
        <div className="card border-0 shadow-sm h-100" style={{ ...cardStyle, width: 400, maxWidth: "100%" }}>
          <div style={headerStyle}>Location Master</div>
          <div className="py-1">
            {LOCATION_MASTERS.map((item) => <SettingItem key={item.label} item={item} />)}
          </div>
        </div>
      </div>
    </div>

    <div className="card border-0 shadow-sm" style={cardStyle}>
      <div style={headerStyle}>Master Configuration</div>
      <div className="row g-0 py-1">
        {MASTER_CONFIGURATION.map((item) => (
          <div key={item.label} className="col-12 col-md-4">
            <SettingItem item={item} />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Setting;
